import { createFileRoute, Link } from '@tanstack/react-router'
import { Users } from 'lucide-react'
import { isFeatureEnabled } from '@/lib/feature-flags'
import { GatedFeaturePlaceholder } from '@/components/GatedFeaturePlaceholder'
import ErrorFallback from '@/components/ErrorFallback'
import { Button } from '@/components/ui/button'
import { EmptyState } from '@/components/ui/empty-state'
import { PageBody, PageContainer } from '@/components/ui/page-container'
import { PageHeader } from '@/components/ui/page-header'

export const Route = createFileRoute('/_authenticated/projects/$projectSlug/members')({
  component: ProjectMembersPage,
  errorComponent: ErrorFallback,
})

export function ProjectMembersPage() {
  const { projectSlug } = Route.useParams()

  if (!isFeatureEnabled('collab')) {
    return (
      <GatedFeaturePlaceholder
        title="Members"
        description="Invite teammates and manage their roles within this project."
        icon={Users}
        flagName="VITE_FF_COLLAB"
      />
    )
  }

  return (
    <PageContainer width="narrow">
      <PageHeader
        eyebrow="Project"
        title="Members"
        description="Invite teammates and manage their access to this project."
      />
      <PageBody>
        <EmptyState
          icon={Users}
          title="No members yet"
          description="Invite a teammate to give them access to this project's documents, prompts, and context packs."
          action={
            <Button asChild size="sm" variant="outline">
              <Link to="/projects/$projectSlug" params={{ projectSlug }}>
                Back to project
              </Link>
            </Button>
          }
        />
      </PageBody>
    </PageContainer>
  )
}
